import React, { useState } from 'react'
import { HelpCircle, Mail, Receipt } from 'lucide-react'
import { Breadcrumb } from '../../components/Common'
import HelpModal from '../../components/HelpModal/HelpModal'
import { useNavigate } from 'react-router-dom'

const NotificationsHub = () => {
  const navigate = useNavigate()
  const [showHelp, setShowHelp] = useState(false)

  const breadcrumbItems = [
    { label: 'Settings', path: '/settings', onClick: () => navigate('/settings') },
    { label: 'Notifications', path: '/settings/notifications', isCurrent: true },
  ]

  const cards = [
    {
      key: 'email',
      title: 'Email Notifications',
      description: 'Event recipients (To / CC / BCC) and the daily digest schedule',
      icon: Mail,
      path: '/settings/email-notifications',
    },
    {
      key: 'gst',
      title: 'GST Reminder & Compliance',
      description: 'GST due-date reminders with sales, purchase, ITC and payable working summary',
      icon: Receipt,
      path: '/settings/gst-reminder-settings',
    },
  ]

  return (
    <div className="sales-dashboard">
      <div className="breadcrumb-section">
        <Breadcrumb
          items={breadcrumbItems}
          rightSlot={
            <button
              type="button"
              className="btn btn-outline-secondary btn-sm d-flex align-items-center gap-1"
              onClick={() => setShowHelp(true)}
              title="Help"
              aria-label="Open help"
            >
              <HelpCircle size={18} />
              <span className="d-none d-sm-inline">Help</span>
            </button>
          }
        />
      </div>

      <div className="page-header">
        <div className="page-title">
          <h1>Notifications</h1>
          <p>Email alerts and GST compliance reminders</p>
        </div>
      </div>

      <div className="settings-masters-grid">
        {cards.map((card) => {
          const Icon = card.icon
          return (
            <div
              key={card.key}
              className="settings-master-card"
              onClick={() => navigate(card.path)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault()
                  navigate(card.path)
                }
              }}
            >
              <div className="settings-master-icon">
                <Icon size={24} />
              </div>
              <div className="settings-master-content">
                <h3>{card.title}</h3>
                <p>{card.description}</p>
              </div>
            </div>
          )
        })}
      </div>

      <HelpModal isOpen={showHelp} onClose={() => setShowHelp(false)} title="Notifications – Help">
        <h3>Notifications</h3>
        <p>Manage <strong>Email Notifications</strong> for system events, and <strong>GST Reminder &amp; Compliance</strong> schedules.</p>
      </HelpModal>
    </div>
  )
}

export default NotificationsHub
